/**
 * Filter Configuration
 * Centralized configuration for product filtering and sorting
 */

export const SORT_TYPES = {
    PRICE_ASC: "priceAsc",
    PRICE_DESC: "priceDesc",
    LOVE_ASC: "loveAsc",
    LOVE_DESC: "loveDesc",
};

export const SORT_LABELS = {
    [SORT_TYPES.PRICE_ASC]: "Price: Low to High",
    [SORT_TYPES.PRICE_DESC]: "Price: High to Low",
    [SORT_TYPES.LOVE_ASC]: "Hearts: Low to High",
    [SORT_TYPES.LOVE_DESC]: "Hearts: High to Low",
};

export const COUNTRY_FILTERS = {
    ALL: "All",
    WORLDWIDE: "Worldwide",
};
